export const deepFreeze = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;

  Object.keys(obj).forEach(prop => {
    if (obj[prop] !== null && typeof obj[prop] === 'object') {
      deepFreeze(obj[prop]);
    }
  });
  return Object.freeze(obj);
};